import { useCompanyValues } from '@/providers';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { UserCard } from '../../UserCard/UserCard';
import { SidebarBase } from '../common';
import { PinButton } from '../common/components/PinButton';
import { EXTERNAL_SIDEBAR_LOGOS } from './constants';
import { ExternalSidebarNavigation } from './ExternalSidebarNavigation';

export const ExternalSidebar: FC = () => {
  const { t } = useTranslation();
  const { company } = useCompanyValues();

  return (
    <SidebarBase>
      {({ onPinClick, pinButtonRef }) => (
        <>
          <div className='flex size-full flex-col'>
            <header
              className={twMerge(
                'hidden shrink-0 flex-col gap-4 items-center overflow-hidden',
                'transition-discrete starting:opacity-0 starting:h-0 motion-safe:transition-[display,opacity,padding,height] motion-safe:delay-200 motion-safe:duration-500',
                'group-data-[expanded=true]/sidebar:flex',
                'group-data-[expanded=false]/sidebar:h-0 group-data-[expanded=false]/sidebar:opacity-0 group-data-[expanded=false]/sidebar:motion-safe:delay-0',
                'group-data-[pinned=true]/sidebar:delay-0'
              )}
            >
              {EXTERNAL_SIDEBAR_LOGOS[company]}
              <p className='mb-4 text-nowrap border-b border-brand-200 pb-4 text-xs font-semibold text-tertiary-hover'>{t('home:poweredByAudiencerate')}</p>
            </header>

            <PinButton onClick={onPinClick} ref={pinButtonRef} />
            <ExternalSidebarNavigation />
          </div>
          <UserCard />
        </>
      )}
    </SidebarBase>
  );
};
